function getSrc(src, { optimize = true } = {}) {
  try {
    const url = new URL(src)

    if (src.includes("filekitcdn.com")) {
      if (!optimize) url.searchParams.append("auto", "")
    }

    return url.toString()
  } catch (e) {
    return src
  }
}

export default getSrc
